import { Controller } from '@hotwired/stimulus'

// Leaving the editor with unpublished edits asks whether to publish them, since
// saved edits stay a draft and classes keep seeing the published version.
export default class extends Controller {
  static targets = ['modal']
  static values = { edited: Boolean }

  disconnect() {
    this.dismiss()
  }

  edit() {
    this.editedValue = true
  }

  leave(event) {
    if (!this.editedValue || event.metaKey || event.ctrlKey || event.shiftKey) return

    event.preventDefault()
    if (this.prompt?.isConnected) return

    this.prompt = this.modalTarget.content.firstElementChild.cloneNode(true)
    this.prompt.dataset.turboTemporary = ''
    document.body.append(this.prompt)
  }

  // Closing the prompt on click would drop its Publish link before Turbo follows it,
  // so it goes once the publish modal has loaded instead.
  dismiss(event) {
    if (event && event.target.id !== 'modal') return

    this.prompt?.remove()
  }
}
